"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var item_1 = require("common/domain/item");
var task_1 = require("common/domain/task");
var lodash_1 = require("lodash");
var effects_1 = require("redux-saga/effects");
var tasks_1 = require("../infra/tasks");
var items_1 = require("./items");
var utils_1 = require("./utils");
var duck = items_1.default("tasks", tasks_1.tasksRepository, task_1.createTask, {
    onToggleTaskState: function (task) { return (__assign({}, task, { updatedAt: Date.now() })); },
    partialInitialState: {
        currentTag: null,
        tags: [],
    },
});
var factory = duck.actionCreatorFactory;
var getTags = factory.async("GET_TAGS");
var setCurrentTag = factory("SET_CURRENT_TAG");
var updateCurrentItem = factory("UPDATE_CURRENT_ITEM");
exports.actionCreators = __assign({}, duck.actionCreators, { getTags: function () { return getTags.started(null); }, setCurrentTag: setCurrentTag,
    updateCurrentItem: updateCurrentItem });
exports.initialState = duck.initialState;
exports.reducer = duck.reducer
    .case(duck.actionCreators.createItem, function (state) { return state.merge({ currentTag: null }); })
    .case(getTags.done, function (state, _a) {
    var result = _a.result;
    return state.merge({ tags: result });
})
    .case(setCurrentTag, function (state, currentTag) { return state.merge({ currentTag: currentTag }); });
exports.sagas = __spread(duck.sagas, [
    utils_1.takeEvery(duck.getItemsActionCreators.done, function _() {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, effects_1.put(exports.actionCreators.getTags())];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }),
    utils_1.takeEvery(getTags.started, function _() {
        var _a, doneItems, todoItems;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, duck.selectState()];
                case 1:
                    _a = _b.sent(), doneItems = _a.doneItems, todoItems = _a.todoItems;
                    return [4 /*yield*/, effects_1.put(getTags.done({
                            params: null,
                            result: task_1.extractTagsFromTasks(__spread(doneItems, todoItems)),
                        }))];
                case 2:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }),
    utils_1.takeEvery(duck.actionCreators.removeItem, function _() {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, effects_1.put(exports.actionCreators.getTags())];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }),
    utils_1.takeEvery(updateCurrentItem, function _(item) {
        var _a, currentItem, doneItems, todoItems, done, items;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    item = __assign({}, item, { updatedAt: Date.now() });
                    return [4 /*yield*/, duck.selectState()];
                case 1:
                    _a = _b.sent(), currentItem = _a.currentItem, doneItems = _a.doneItems, todoItems = _a.todoItems;
                    done = item_1.include(doneItems, item);
                    items = __spread((done ? doneItems : todoItems));
                    items[lodash_1.findIndex(items, { id: currentItem.id })] = item;
                    return [4 /*yield*/, effects_1.put(exports.actionCreators.setItems(items, done))];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, effects_1.put(exports.actionCreators.setCurrentItem(item))];
                case 3:
                    _b.sent();
                    return [4 /*yield*/, effects_1.put(exports.actionCreators.getTags())];
                case 4:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }),
]);
exports.persistent = true;
exports.storeInitializer = duck.storeInitializer;



//////////////////
// WEBPACK FOOTER
// ./src/redux/tasks.ts
// module id = 36
// module chunks = 0